import { apiUrl } from "../constants/global";
import { getCurrentLocale, getLoggedUser } from "../state/user";
const lang = getCurrentLocale();

async function getAllCalendarData() {
  return fetch(apiUrl + "v2/auc_calendar?locale=" + lang, {
    method: "GET",
  }).then((data) => data.json());
}

export { getAllCalendarData };
